module.exports = (parcelRequire.load("ci0YQ")).then(() => parcelRequire('hN2V7'));